/**
 * Modern Portrait-Image “contain” Toggler (Performance Optimized)
 *
 * Handles both static and dynamically injected grid/gallery images by:
 * 1. Initial scan on DOMContentLoaded / Script execution.
 * 2. Using MutationObserver to detect new images instantly (AJAX/Infinite Scroll).
 * 3. Monitoring each image’s load event for accurate natural dimensions.
 * 4. Unique scoping to prevent variable collisions with other scripts.
 *
 * Targets:
 * • img.main-slide-img
 * • img.imageslide-item_image
 * • img.swiper-slide-image
 * • #product-grid .main-preview-img
 *
 * Logic:
 * - Portrait (naturalHeight > naturalWidth) → add `.contain` class.
 * - Landscape/Square → remove `.contain` class.
 *
 * CSS requirement:
 * .main-preview-img.contain, .main-slide-img.contain, 
 * .imageslide-item_image.contain, .swiper-slide-image.contain {
 * object-fit: contain !important;
 * }
 */

(function() {
  const SELECTORS = [
    "img.main-slide-img",
    "img.imageslide-item_image",
    "img.swiper-slide-image",
    "img.main-second-img",
    "img.hover-second-img"
  ].join(", ");

  function applyContainLogic(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    
    // Rollovers always stay 'cover', so we skip the '.contain' class
    const isRollover = img.classList.contains('main-second-img') || 
                       img.classList.contains('hover-second-img');

    if (!isRollover) {
      const isPortrait = img.naturalHeight > img.naturalWidth;
      if (isPortrait) img.classList.add("contain");
    }
    
    img.dataset.containChecked = "true"; 
  }

  function processTargetImage(img) {
    if (img.dataset.containChecked === "true") return;

    if (!img.complete) {
      img.addEventListener("load", () => applyContainLogic(img), { once: true });
    } else {
      applyContainLogic(img);
    }
  }

  function scanForPortraitImages(container = document) {
    if (!container.querySelectorAll) return;
    container.querySelectorAll(SELECTORS).forEach(processTargetImage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scanForPortraitImages());
  } else {
    scanForPortraitImages();
  }

  const portraitContainObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        // Only process Element nodes
        if (node.nodeType !== 1) continue;

        // SKIP REVIEWS: If the node or its parent is a review/recharge widget, ignore it
        if (
          node.classList.contains('recharge-reviews') || 
          node.classList.contains('stamped-badge') ||
          node.closest('.stamped-badge, .recharge-widget, #stamped-main-widget')
        ) {
          continue; 
        }
        
        // Process images
        if (node.matches(SELECTORS)) processTargetImage(node);
        scanForPortraitImages(node);
      }
    }
  });

  const observationTarget = document.getElementById('product-grid') || document.body;
  portraitContainObserver.observe(observationTarget, { childList: true, subtree: true });

  window.addEventListener("resize", () => scanForPortraitImages(), { passive: true });
})();